module.exports = __webpack_public_path__ + "static/media/1 - Design.b4309a83.png";